module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-7aa1845a8c20e052927edf782fefa8c1.png";